import { render } from "./DbSubscribeEditorCmp.vue?vue&type=template&id=1cb2b99c"
import script from "./DbSubscribeEditorCmp.vue?vue&type=script&lang=js"
export * from "./DbSubscribeEditorCmp.vue?vue&type=script&lang=js"

import "./DbSubscribeEditorCmp.vue?vue&type=style&index=0&id=1cb2b99c&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__